import React from "react";
import { Flame } from "lucide-react";

/**
 * BrandFlame
 * ----------
 * Lucide flame icon wrapped in a CSS-animated flicker. When a `streak`
 * (consecutive workout days) is provided, the flame's speed, glow, and
 * color scale with it:
 *   0        -> ember   (slow, dim)
 *   1-2      -> lit     (default flicker)
 *   3-6      -> hot     (faster, brighter)
 *   7-13     -> blaze   (fast, strong glow, lighter blue)
 *   14+      -> inferno (rapid, max glow, icy-white core)
 * Without a streak prop it behaves exactly like the original always-on
 * flicker (used on logged-out pages). Pure CSS via tier classes in
 * index.css. Respects `prefers-reduced-motion: reduce`.
 */
function tierFor(streak) {
  if (streak === null || streak === undefined) return "";
  if (streak <= 0) return "brand-flame--ember";
  if (streak <= 2) return "";
  if (streak <= 6) return "brand-flame--hot";
  if (streak <= 13) return "brand-flame--blaze";
  return "brand-flame--inferno";
}

export default function BrandFlame({ className = "w-6 h-6", strokeWidth = 2.5, streak = null }) {
  const tier = tierFor(streak);
  const title = streak === null || streak === undefined
    ? undefined
    : streak > 0 ? `${streak}-day workout streak` : "No active streak — train today to light it up";
  return (
    <span data-testid="brand-flame" data-streak={streak ?? undefined} title={title} className={`brand-flame inline-flex ${tier} ${className}`}>
      <Flame className="w-full h-full" strokeWidth={strokeWidth} />
    </span>
  );
}
